
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecd20"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecd20"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

parcelRegister("eT66s", function(module, exports) {

$parcel$export(module.exports, "FontLoader", () => $ad6aefaf36d08024$export$812303d6cad736b3);

var $ilwiq = parcelRequire("ilwiq");
class $ad6aefaf36d08024$export$812303d6cad736b3 extends (0, $ilwiq.Loader) {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new (0, $ilwiq.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            const font = scope.parse(JSON.parse(text));
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    }
    parse(json) {
        return new $ad6aefaf36d08024$export$89abf52a030e56ee(json);
    }
}
//
class $ad6aefaf36d08024$export$89abf52a030e56ee {
    constructor(data){
        this.isFont = true;
        this.type = "Font";
        this.data = data;
    }
    generateShapes(text, size = 100) {
        const shapes = [];
        const paths = $ad6aefaf36d08024$var$createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)shapes.push(...paths[p].toShapes());
        return shapes;
    }
}
function $ad6aefaf36d08024$var$createPaths(text, size, data) {
    const chars = Array.from(text);
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === "\n") {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $ad6aefaf36d08024$var$createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function $ad6aefaf36d08024$var$createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs["?"];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + ".");
        return;
    }
    const path = new (0, $ilwiq.ShapePath)();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(" "));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case "m":
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case "l":
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case "q":
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case "b":
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}

});

parcelRegister("8NFZ6", function(module, exports) {

$parcel$export(module.exports, "TextGeometry", () => $66837798a125d1c7$export$684b774b4473ba5f);
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ 
var $ilwiq = parcelRequire("ilwiq");
class $66837798a125d1c7$export$684b774b4473ba5f extends (0, $ilwiq.ExtrudeGeometry) {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (font === undefined) super(); // generate default extrude geometry
        else {
            const shapes = font.generateShapes(text, parameters.size);
            // translate parameters to ExtrudeGeometry API
            parameters.depth = parameters.height !== undefined ? parameters.height : 50;
            // defaults
            if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
            if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
            if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
            super(shapes, parameters);
        }
        this.type = "TextGeometry";
    }
}

});

parcelRegister("2HSCJ", function(module, exports) {

$parcel$export(module.exports, "EffectComposer", () => $1f89f80dfbd5e815$export$7fe01e6ab8aa748c);

var $ilwiq = parcelRequire("ilwiq");

var $45fwF = parcelRequire("45fwF");

var $9ajTk = parcelRequire("9ajTk");

var $1jmvW = parcelRequire("1jmvW");
class $1f89f80dfbd5e815$export$7fe01e6ab8aa748c {
    constructor(renderer, renderTarget){
        this.renderer = renderer;
        this._pixelRatio = renderer.getPixelRatio();
        if (renderTarget === undefined) {
            const size = renderer.getSize(new (0, $ilwiq.Vector2)());
            this._width = size.width;
            this._height = size.height;
            renderTarget = new (0, $ilwiq.WebGLRenderTarget)(this._width * this._pixelRatio, this._height * this._pixelRatio, {
                type: (0, $ilwiq.HalfFloatType)
            });
            renderTarget.texture.name = "EffectComposer.rt1";
        } else {
            this._width = renderTarget.width;
            this._height = renderTarget.height;
        }
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.renderTarget2.texture.name = "EffectComposer.rt2";
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
        this.renderToScreen = true;
        this.passes = [];
        this.copyPass = new (0, $9ajTk.ShaderPass)((0, $45fwF.CopyShader));
        this.copyPass.material.blending = (0, $ilwiq.NoBlending);
        this.clock = new (0, $ilwiq.Clock)();
    }
    swapBuffers() {
        const tmp = this.readBuffer;
        this.readBuffer = this.writeBuffer;
        this.writeBuffer = tmp;
    }
    addPass(pass) {
        this.passes.push(pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    insertPass(pass, index) {
        this.passes.splice(index, 0, pass);
        pass.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
    }
    removePass(pass) {
        const index = this.passes.indexOf(pass);
        if (index !== -1) this.passes.splice(index, 1);
    }
    isLastEnabledPass(passIndex) {
        for(let i = passIndex + 1; i < this.passes.length; i++){
            if (this.passes[i].enabled) return false;
        }
        return true;
    }
    render(deltaTime) {
        // deltaTime value is in seconds
        if (deltaTime === undefined) deltaTime = this.clock.getDelta();
        const currentRenderTarget = this.renderer.getRenderTarget();
        let maskActive = false;
        for(let i = 0, il = this.passes.length; i < il; i++){
            const pass = this.passes[i];
            if (pass.enabled === false) continue;
            pass.renderToScreen = this.renderToScreen && this.isLastEnabledPass(i);
            pass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime, maskActive);
            if (pass.needsSwap) {
                if (maskActive) {
                    const context = this.renderer.getContext();
                    const stencil = this.renderer.state.buffers.stencil;
                    //context.stencilFunc( context.NOTEQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.NOTEQUAL, 1, 0xffffffff);
                    this.copyPass.render(this.renderer, this.writeBuffer, this.readBuffer, deltaTime);
                    //context.stencilFunc( context.EQUAL, 1, 0xffffffff );
                    stencil.setFunc(context.EQUAL, 1, 0xffffffff);
                }
                this.swapBuffers();
            }
            if ((0, $1jmvW.MaskPass) !== undefined) {
                if (pass instanceof (0, $1jmvW.MaskPass)) maskActive = true;
                else if (pass instanceof (0, $1jmvW.ClearMaskPass)) maskActive = false;
            }
        }
        this.renderer.setRenderTarget(currentRenderTarget);
    }
    reset(renderTarget) {
        if (renderTarget === undefined) {
            const size = this.renderer.getSize(new (0, $ilwiq.Vector2)());
            this._pixelRatio = this.renderer.getPixelRatio();
            this._width = size.width;
            this._height = size.height;
            renderTarget = this.renderTarget1.clone();
            renderTarget.setSize(this._width * this._pixelRatio, this._height * this._pixelRatio);
        }
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.renderTarget1 = renderTarget;
        this.renderTarget2 = renderTarget.clone();
        this.writeBuffer = this.renderTarget1;
        this.readBuffer = this.renderTarget2;
    }
    setSize(width, height) {
        this._width = width;
        this._height = height;
        const effectiveWidth = this._width * this._pixelRatio;
        const effectiveHeight = this._height * this._pixelRatio;
        this.renderTarget1.setSize(effectiveWidth, effectiveHeight);
        this.renderTarget2.setSize(effectiveWidth, effectiveHeight);
        for(let i = 0; i < this.passes.length; i++)this.passes[i].setSize(effectiveWidth, effectiveHeight);
    }
    setPixelRatio(pixelRatio) {
        this._pixelRatio = pixelRatio;
        this.setSize(this._width, this._height);
    }
    dispose() {
        this.renderTarget1.dispose();
        this.renderTarget2.dispose();
        this.copyPass.dispose();
    }
}

});
parcelRegister("45fwF", function(module, exports) {

$parcel$export(module.exports, "CopyShader", () => $2f93ac2d46312da9$export$57f84a24a9a6130d);
/**
 * Full-screen textured quad shader
 */ const $2f93ac2d46312da9$export$57f84a24a9a6130d = {
    name: "CopyShader",
    uniforms: {
        "tDiffuse": {
            value: null
        },
        "opacity": {
            value: 1.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform float opacity;

		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		void main() {

			vec4 texel = texture2D( tDiffuse, vUv );
			gl_FragColor = opacity * texel;


		}`
};

});

parcelRegister("9ajTk", function(module, exports) {

$parcel$export(module.exports, "ShaderPass", () => $6ac47a3de6300e1f$export$c55093fd4f9e42f0);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");
class $6ac47a3de6300e1f$export$c55093fd4f9e42f0 extends (0, $RPVlj.Pass) {
    constructor(shader, textureID){
        super();
        this.textureID = textureID !== undefined ? textureID : "tDiffuse";
        if (shader instanceof (0, $ilwiq.ShaderMaterial)) {
            this.uniforms = shader.uniforms;
            this.material = shader;
        } else if (shader) {
            this.uniforms = (0, $ilwiq.UniformsUtils).clone(shader.uniforms);
            this.material = new (0, $ilwiq.ShaderMaterial)({
                name: shader.name !== undefined ? shader.name : "unspecified",
                defines: Object.assign({}, shader.defines),
                uniforms: this.uniforms,
                vertexShader: shader.vertexShader,
                fragmentShader: shader.fragmentShader
            });
        }
        this.fsQuad = new (0, $RPVlj.FullScreenQuad)(this.material);
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        if (this.uniforms[this.textureID]) this.uniforms[this.textureID].value = readBuffer.texture;
        this.fsQuad.material = this.material;
        if (this.renderToScreen) {
            renderer.setRenderTarget(null);
            this.fsQuad.render(renderer);
        } else {
            renderer.setRenderTarget(writeBuffer);
            // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
            if (this.clear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
            this.fsQuad.render(renderer);
        }
    }
    dispose() {
        this.material.dispose();
        this.fsQuad.dispose();
    }
}

});
parcelRegister("RPVlj", function(module, exports) {

$parcel$export(module.exports, "Pass", () => $0a1d3a5a6a49de03$export$802bc10488da99c7);
$parcel$export(module.exports, "FullScreenQuad", () => $0a1d3a5a6a49de03$export$3983474c8e6e978b);

var $ilwiq = parcelRequire("ilwiq");
class $0a1d3a5a6a49de03$export$802bc10488da99c7 {
    constructor(){
        this.isPass = true;
        // if set to true, the pass is processed by the composer
        this.enabled = true;
        // if set to true, the pass indicates to swap read and write buffer after rendering
        this.needsSwap = true;
        // if set to true, the pass clears its buffer before rendering
        this.clear = false;
        // if set to true, the result of the pass is rendered to screen. This is set automatically by EffectComposer.
        this.renderToScreen = false;
    }
    setSize() {}
    render() {
        console.error("THREE.Pass: .render() must be implemented in derived pass.");
    }
    dispose() {}
}
// Helper for passes that need to fill the viewport with a single quad.
const $0a1d3a5a6a49de03$var$_camera = new (0, $ilwiq.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
// https://github.com/mrdoob/three.js/pull/21358
const $0a1d3a5a6a49de03$var$_geometry = new (0, $ilwiq.BufferGeometry)();
$0a1d3a5a6a49de03$var$_geometry.setAttribute("position", new (0, $ilwiq.Float32BufferAttribute)([
    -1,
    3,
    0,
    -1,
    -1,
    0,
    3,
    -1,
    0
], 3));
$0a1d3a5a6a49de03$var$_geometry.setAttribute("uv", new (0, $ilwiq.Float32BufferAttribute)([
    0,
    2,
    0,
    0,
    2,
    0
], 2));
class $0a1d3a5a6a49de03$export$3983474c8e6e978b {
    constructor(material){
        this._mesh = new (0, $ilwiq.Mesh)($0a1d3a5a6a49de03$var$_geometry, material);
    }
    dispose() {
        this._mesh.geometry.dispose();
    }
    render(renderer) {
        renderer.render(this._mesh, $0a1d3a5a6a49de03$var$_camera);
    }
    get material() {
        return this._mesh.material;
    }
    set material(value) {
        this._mesh.material = value;
    }
}

});


parcelRegister("1jmvW", function(module, exports) {

$parcel$export(module.exports, "MaskPass", () => $0f4907a355572481$export$bb424a4005d6dde0);
$parcel$export(module.exports, "ClearMaskPass", () => $0f4907a355572481$export$8d8650aed29c6251);

var $RPVlj = parcelRequire("RPVlj");
class $0f4907a355572481$export$bb424a4005d6dde0 extends (0, $RPVlj.Pass) {
    constructor(scene, camera){
        super();
        this.scene = scene;
        this.camera = camera;
        this.clear = true;
        this.needsSwap = false;
        this.inverse = false;
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const context = renderer.getContext();
        const state = renderer.state;
        // don't update color or depth
        state.buffers.color.setMask(false);
        state.buffers.depth.setMask(false);
        // lock buffers
        state.buffers.color.setLocked(true);
        state.buffers.depth.setLocked(true);
        // set up stencil
        let writeValue, clearValue;
        if (this.inverse) {
            writeValue = 0;
            clearValue = 1;
        } else {
            writeValue = 1;
            clearValue = 0;
        }
        state.buffers.stencil.setTest(true);
        state.buffers.stencil.setOp(context.REPLACE, context.REPLACE, context.REPLACE);
        state.buffers.stencil.setFunc(context.ALWAYS, writeValue, 0xffffffff);
        state.buffers.stencil.setClear(clearValue);
        state.buffers.stencil.setLocked(true);
        // draw into the stencil buffer
        renderer.setRenderTarget(readBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        renderer.setRenderTarget(writeBuffer);
        if (this.clear) renderer.clear();
        renderer.render(this.scene, this.camera);
        // unlock color and depth buffer and make them writable for subsequent rendering/clearing
        state.buffers.color.setLocked(false);
        state.buffers.depth.setLocked(false);
        state.buffers.color.setMask(true);
        state.buffers.depth.setMask(true);
        // only render where stencil is set to 1
        state.buffers.stencil.setLocked(false);
        state.buffers.stencil.setFunc(context.EQUAL, 1, 0xffffffff); // draw if == 1
        state.buffers.stencil.setOp(context.KEEP, context.KEEP, context.KEEP);
        state.buffers.stencil.setLocked(true);
    }
}
class $0f4907a355572481$export$8d8650aed29c6251 extends (0, $RPVlj.Pass) {
    constructor(){
        super();
        this.needsSwap = false;
    }
    render(renderer /*, writeBuffer, readBuffer, deltaTime, maskActive */ ) {
        renderer.state.buffers.stencil.setLocked(false);
        renderer.state.buffers.stencil.setTest(false);
    }
}

});


parcelRegister("l1cPW", function(module, exports) {

$parcel$export(module.exports, "RenderPass", () => $f4d3a60efece63cd$export$f63ea822f020b5b0);

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");
class $f4d3a60efece63cd$export$f63ea822f020b5b0 extends (0, $RPVlj.Pass) {
    constructor(scene, camera, overrideMaterial = null, clearColor = null, clearAlpha = null){
        super();
        this.scene = scene;
        this.camera = camera;
        this.overrideMaterial = overrideMaterial;
        this.clearColor = clearColor;
        this.clearAlpha = clearAlpha;
        this.clear = true;
        this.clearDepth = false;
        this.needsSwap = false;
        this._oldClearColor = new (0, $ilwiq.Color)();
    }
    render(renderer, writeBuffer, readBuffer /*, deltaTime, maskActive */ ) {
        const oldAutoClear = renderer.autoClear;
        renderer.autoClear = false;
        let oldClearAlpha, oldOverrideMaterial;
        if (this.overrideMaterial !== null) {
            oldOverrideMaterial = this.scene.overrideMaterial;
            this.scene.overrideMaterial = this.overrideMaterial;
        }
        if (this.clearColor !== null) {
            renderer.getClearColor(this._oldClearColor);
            renderer.setClearColor(this.clearColor);
        }
        if (this.clearAlpha !== null) {
            oldClearAlpha = renderer.getClearAlpha();
            renderer.setClearAlpha(this.clearAlpha);
        }
        if (this.clearDepth == true) renderer.clearDepth();
        renderer.setRenderTarget(this.renderToScreen ? null : readBuffer);
        if (this.clear === true) // TODO: Avoid using autoClear properties, see https://github.com/mrdoob/three.js/pull/15571#issuecomment-465669600
        renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        renderer.render(this.scene, this.camera);
        // restore
        if (this.clearColor !== null) renderer.setClearColor(this._oldClearColor);
        if (this.clearAlpha !== null) renderer.setClearAlpha(oldClearAlpha);
        if (this.overrideMaterial !== null) this.scene.overrideMaterial = oldOverrideMaterial;
        renderer.autoClear = oldAutoClear;
    }
}

});

parcelRegister("3YnPA", function(module, exports) {
module.exports = new URL("mobile.9653a1cc.glb", import.meta.url).toString();

});

var $bbcbfefe4e40aaa2$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["eZSXb","index.27f6964e.js","k2Ppr","0b.914eb0c8.png","ajxUC","0l.63b0fd01.png","iFMNY","0pa.2fa2a8a3.png","irshu","0pi.7ff142dc.png","ipxlF","0s.a30fcd21.png","bCUzV","0t.608f359d.png","atuxL","1.5689592e.png","lgkMT","1b.e5f99c8d.png","lvITC","1l.650f3cd1.png","662G3","1pa.4f2f1922.png","aNbEQ","1pi.e2890185.png","7eJxQ","1t.9862eb09.png","ftXFo","2.5f2e0f39.png","6zVXi","3.142232ea.png","9Lz7t","4.d0e36cdd.png","beIse","5.e99cfe39.png","l3SHO","poplow.eed5497b.mp3","37zQU","pophigh.5b35f8ed.mp3","bf8eB","boing.92429357.mp3","izXye","speaker.20e5ad03.glb","gR8JA","pattern.3023fd2d.glb","d0VZk","waves.15dc2590.glb","ofxLg","particles.8d1cc640.glb","akbSI","mobile.9653a1cc.glb","6Mcez","desktop.a16d3532.glb","kQilI","audio.026e0227.js","b43xA","audio.8216a66e.js","eroNK","diorama.1ed539c4.js","5h9CN","index.c7040afe.css"]'));


parcelRequire("gN9y1");

var $ilwiq = parcelRequire("ilwiq");

var $7lx9d = parcelRequire("7lx9d");

var $eT66s = parcelRequire("eT66s");

var $8NFZ6 = parcelRequire("8NFZ6");

var $2HSCJ = parcelRequire("2HSCJ");

var $l1cPW = parcelRequire("l1cPW");

var $9ajTk = parcelRequire("9ajTk");

var $ilwiq = parcelRequire("ilwiq");

var $RPVlj = parcelRequire("RPVlj");

var $45fwF = parcelRequire("45fwF");
class $3b5dbdf1656506ea$export$356dcb7105dbd3ee extends (0, $RPVlj.Pass) {
    constructor(resolution, scene, camera, selectedObjects){
        super();
        this.renderScene = scene;
        this.renderCamera = camera;
        this.selectedObjects = selectedObjects !== undefined ? selectedObjects : [];
        this.visibleEdgeColor = new (0, $ilwiq.Color)(1, 1, 1);
        this.hiddenEdgeColor = new (0, $ilwiq.Color)(0.1, 0.04, 0.02);
        this.edgeGlow = 0.0;
        this.usePatternTexture = false;
        this.edgeThickness = 1.0;
        this.edgeStrength = 3.0;
        this.downSampleRatio = 2;
        this.pulsePeriod = 0;
        this._visibilityCache = new Map();
        this.resolution = resolution !== undefined ? new (0, $ilwiq.Vector2)(resolution.x, resolution.y) : new (0, $ilwiq.Vector2)(256, 256);
        const resx = Math.round(this.resolution.x / this.downSampleRatio);
        const resy = Math.round(this.resolution.y / this.downSampleRatio);
        this.renderTargetMaskBuffer = new (0, $ilwiq.WebGLRenderTarget)(this.resolution.x, this.resolution.y);
        this.renderTargetMaskBuffer.texture.name = "OutlinePass.mask";
        this.renderTargetMaskBuffer.texture.generateMipmaps = false;
        this.depthMaterial = new (0, $ilwiq.MeshDepthMaterial)();
        this.depthMaterial.side = (0, $ilwiq.DoubleSide);
        this.depthMaterial.depthPacking = (0, $ilwiq.RGBADepthPacking);
        this.depthMaterial.blending = (0, $ilwiq.NoBlending);
        this.prepareMaskMaterial = this.getPrepareMaskMaterial();
        this.prepareMaskMaterial.side = (0, $ilwiq.DoubleSide);
        this.prepareMaskMaterial.fragmentShader = replaceDepthToViewZ(this.prepareMaskMaterial.fragmentShader, this.renderCamera);
        this.renderTargetDepthBuffer = new (0, $ilwiq.WebGLRenderTarget)(this.resolution.x, this.resolution.y, {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetDepthBuffer.texture.name = "OutlinePass.depth";
        this.renderTargetDepthBuffer.texture.generateMipmaps = false;
        this.renderTargetMaskDownSampleBuffer = new (0, $ilwiq.WebGLRenderTarget)(resx, resy, {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetMaskDownSampleBuffer.texture.name = "OutlinePass.depthDownSample";
        this.renderTargetMaskDownSampleBuffer.texture.generateMipmaps = false;
        this.renderTargetBlurBuffer1 = new (0, $ilwiq.WebGLRenderTarget)(resx, resy, {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetBlurBuffer1.texture.name = "OutlinePass.blur1";
        this.renderTargetBlurBuffer1.texture.generateMipmaps = false;
        this.renderTargetBlurBuffer2 = new (0, $ilwiq.WebGLRenderTarget)(Math.round(resx / 2), Math.round(resy / 2), {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetBlurBuffer2.texture.name = "OutlinePass.blur2";
        this.renderTargetBlurBuffer2.texture.generateMipmaps = false;
        this.edgeDetectionMaterial = this.getEdgeDetectionMaterial();
        this.renderTargetEdgeBuffer1 = new (0, $ilwiq.WebGLRenderTarget)(resx, resy, {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetEdgeBuffer1.texture.name = "OutlinePass.edge1";
        this.renderTargetEdgeBuffer1.texture.generateMipmaps = false;
        this.renderTargetEdgeBuffer2 = new (0, $ilwiq.WebGLRenderTarget)(Math.round(resx / 2), Math.round(resy / 2), {
            type: (0, $ilwiq.HalfFloatType)
        });
        this.renderTargetEdgeBuffer2.texture.name = "OutlinePass.edge2";
        this.renderTargetEdgeBuffer2.texture.generateMipmaps = false;
        const MAX_EDGE_THICKNESS = 4;
        const MAX_EDGE_GLOW = 4;
        this.separableBlurMaterial1 = this.getSeperableBlurMaterial(MAX_EDGE_THICKNESS);
        this.separableBlurMaterial1.uniforms["texSize"].value.set(resx, resy);
        this.separableBlurMaterial1.uniforms["kernelRadius"].value = 1;
        this.separableBlurMaterial2 = this.getSeperableBlurMaterial(MAX_EDGE_GLOW);
        this.separableBlurMaterial2.uniforms["texSize"].value.set(Math.round(resx / 2), Math.round(resy / 2));
        this.separableBlurMaterial2.uniforms["kernelRadius"].value = MAX_EDGE_GLOW;
        // Overlay material
        this.overlayMaterial = this.getOverlayMaterial();
        // copy material
        const copyShader = (0, $45fwF.CopyShader);
        this.copyUniforms = (0, $ilwiq.UniformsUtils).clone(copyShader.uniforms);
        this.materialCopy = new (0, $ilwiq.ShaderMaterial)({
            uniforms: this.copyUniforms,
            vertexShader: copyShader.vertexShader,
            fragmentShader: copyShader.fragmentShader,
            blending: (0, $ilwiq.NoBlending),
            depthTest: false,
            depthWrite: false
        });
        this.enabled = true;
        this.needsSwap = false;
        this._oldClearColor = new (0, $ilwiq.Color)();
        this.oldClearAlpha = 1;
        this.fsQuad = new (0, $RPVlj.FullScreenQuad)(null);
        this.tempPulseColor1 = new (0, $ilwiq.Color)();
        this.tempPulseColor2 = new (0, $ilwiq.Color)();
        this.textureMatrix = new (0, $ilwiq.Matrix4)();
        function replaceDepthToViewZ(string, camera) {
            const type = camera.isPerspectiveCamera ? "perspective" : "orthographic";
            return string.replace(/DEPTH_TO_VIEW_Z/g, type + "DepthToViewZ");
        }
    }
    dispose() {
        this.renderTargetMaskBuffer.dispose();
        this.renderTargetDepthBuffer.dispose();
        this.renderTargetMaskDownSampleBuffer.dispose();
        this.renderTargetBlurBuffer1.dispose();
        this.renderTargetBlurBuffer2.dispose();
        this.renderTargetEdgeBuffer1.dispose();
        this.renderTargetEdgeBuffer2.dispose();
        this.depthMaterial.dispose();
        this.prepareMaskMaterial.dispose();
        this.edgeDetectionMaterial.dispose();
        this.separableBlurMaterial1.dispose();
        this.separableBlurMaterial2.dispose();
        this.overlayMaterial.dispose();
        this.materialCopy.dispose();
        this.fsQuad.dispose();
    }
    setSize(width, height) {
        this.renderTargetMaskBuffer.setSize(width, height);
        this.renderTargetDepthBuffer.setSize(width, height);
        let resx = Math.round(width / this.downSampleRatio);
        let resy = Math.round(height / this.downSampleRatio);
        this.renderTargetMaskDownSampleBuffer.setSize(resx, resy);
        this.renderTargetBlurBuffer1.setSize(resx, resy);
        this.renderTargetEdgeBuffer1.setSize(resx, resy);
        this.separableBlurMaterial1.uniforms["texSize"].value.set(resx, resy);
        resx = Math.round(resx / 2);
        resy = Math.round(resy / 2);
        this.renderTargetBlurBuffer2.setSize(resx, resy);
        this.renderTargetEdgeBuffer2.setSize(resx, resy);
        this.separableBlurMaterial2.uniforms["texSize"].value.set(resx, resy);
    }
    changeVisibilityOfSelectedObjects(bVisible) {
        const cache = this._visibilityCache;
        function gatherSelectedMeshesCallBack(object) {
            if (object.isMesh) {
                if (bVisible === true) object.visible = cache.get(object);
                else {
                    cache.set(object, object.visible);
                    object.visible = bVisible;
                }
            }
        }
        for(let i = 0; i < this.selectedObjects.length; i++){
            const selectedObject = this.selectedObjects[i];
            selectedObject.traverse(gatherSelectedMeshesCallBack);
        }
    }
    changeVisibilityOfNonSelectedObjects(bVisible) {
        const cache = this._visibilityCache;
        const selectedMeshes = [];
        function gatherSelectedMeshesCallBack(object) {
            if (object.isMesh) selectedMeshes.push(object);
        }
        for(let i = 0; i < this.selectedObjects.length; i++){
            const selectedObject = this.selectedObjects[i];
            selectedObject.traverse(gatherSelectedMeshesCallBack);
        }
        function VisibilityChangeCallBack(object) {
            if (object.isMesh || object.isSprite) {
                // only meshes and sprites are supported by OutlinePass
                let bFound = false;
                for(let i = 0; i < selectedMeshes.length; i++){
                    const selectedObjectId = selectedMeshes[i].id;
                    if (selectedObjectId === object.id) {
                        bFound = true;
                        break;
                    }
                }
                if (bFound === false) {
                    const visibility = object.visible;
                    if (bVisible === false || cache.get(object) === true) object.visible = bVisible;
                    cache.set(object, visibility);
                }
            } else if (object.isPoints || object.isLine) {
                // the visibilty of points and lines is always set to false in order to
                // not affect the outline computation
                if (bVisible === true) object.visible = cache.get(object); // restore
                else {
                    cache.set(object, object.visible);
                    object.visible = bVisible;
                }
            }
        }
        this.renderScene.traverse(VisibilityChangeCallBack);
    }
    updateTextureMatrix() {
        this.textureMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        this.textureMatrix.multiply(this.renderCamera.projectionMatrix);
        this.textureMatrix.multiply(this.renderCamera.matrixWorldInverse);
    }
    render(renderer, writeBuffer, readBuffer, deltaTime, maskActive) {
        if (this.selectedObjects.length > 0) {
            renderer.getClearColor(this._oldClearColor);
            this.oldClearAlpha = renderer.getClearAlpha();
            const oldAutoClear = renderer.autoClear;
            renderer.autoClear = false;
            if (maskActive) renderer.state.buffers.stencil.setTest(false);
            renderer.setClearColor(0xffffff, 1);
            // Make selected objects invisible
            this.changeVisibilityOfSelectedObjects(false);
            const currentBackground = this.renderScene.background;
            this.renderScene.background = null;
            // 1. Draw Non Selected objects in the depth buffer
            this.renderScene.overrideMaterial = this.depthMaterial;
            renderer.setRenderTarget(this.renderTargetDepthBuffer);
            renderer.clear();
            renderer.render(this.renderScene, this.renderCamera);
            // Make selected objects visible
            this.changeVisibilityOfSelectedObjects(true);
            this._visibilityCache.clear();
            // Update Texture Matrix for Depth compare
            this.updateTextureMatrix();
            // Make non selected objects invisible, and draw only the selected objects, by comparing the depth buffer of non selected objects
            this.changeVisibilityOfNonSelectedObjects(false);
            this.renderScene.overrideMaterial = this.prepareMaskMaterial;
            this.prepareMaskMaterial.uniforms["cameraNearFar"].value.set(this.renderCamera.near, this.renderCamera.far);
            this.prepareMaskMaterial.uniforms["depthTexture"].value = this.renderTargetDepthBuffer.texture;
            this.prepareMaskMaterial.uniforms["textureMatrix"].value = this.textureMatrix;
            renderer.setRenderTarget(this.renderTargetMaskBuffer);
            renderer.clear();
            renderer.render(this.renderScene, this.renderCamera);
            this.renderScene.overrideMaterial = null;
            this.changeVisibilityOfNonSelectedObjects(true);
            this._visibilityCache.clear();
            this.renderScene.background = currentBackground;
            // 2. Downsample to Half resolution
            this.fsQuad.material = this.materialCopy;
            this.copyUniforms["tDiffuse"].value = this.renderTargetMaskBuffer.texture;
            renderer.setRenderTarget(this.renderTargetMaskDownSampleBuffer);
            renderer.clear();
            this.fsQuad.render(renderer);
            this.tempPulseColor1.copy(this.visibleEdgeColor);
            this.tempPulseColor2.copy(this.hiddenEdgeColor);
            if (this.pulsePeriod > 0) {
                const scalar = 0.625 + Math.cos(performance.now() * 0.01 / this.pulsePeriod) * 0.75 / 2;
                this.tempPulseColor1.multiplyScalar(scalar);
                this.tempPulseColor2.multiplyScalar(scalar);
            }
            // 3. Apply Edge Detection Pass
            this.fsQuad.material = this.edgeDetectionMaterial;
            this.edgeDetectionMaterial.uniforms["maskTexture"].value = this.renderTargetMaskDownSampleBuffer.texture;
            this.edgeDetectionMaterial.uniforms["texSize"].value.set(this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height);
            this.edgeDetectionMaterial.uniforms["visibleEdgeColor"].value = this.tempPulseColor1;
            this.edgeDetectionMaterial.uniforms["hiddenEdgeColor"].value = this.tempPulseColor2;
            renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
            renderer.clear();
            this.fsQuad.render(renderer);
            // 4. Apply Blur on Half res
            this.fsQuad.material = this.separableBlurMaterial1;
            this.separableBlurMaterial1.uniforms["colorTexture"].value = this.renderTargetEdgeBuffer1.texture;
            this.separableBlurMaterial1.uniforms["direction"].value = $3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionX;
            this.separableBlurMaterial1.uniforms["kernelRadius"].value = this.edgeThickness;
            renderer.setRenderTarget(this.renderTargetBlurBuffer1);
            renderer.clear();
            this.fsQuad.render(renderer);
            this.separableBlurMaterial1.uniforms["colorTexture"].value = this.renderTargetBlurBuffer1.texture;
            this.separableBlurMaterial1.uniforms["direction"].value = $3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionY;
            renderer.setRenderTarget(this.renderTargetEdgeBuffer1);
            renderer.clear();
            this.fsQuad.render(renderer);
            // Apply Blur on quarter res
            this.fsQuad.material = this.separableBlurMaterial2;
            this.separableBlurMaterial2.uniforms["colorTexture"].value = this.renderTargetEdgeBuffer1.texture;
            this.separableBlurMaterial2.uniforms["direction"].value = $3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionX;
            renderer.setRenderTarget(this.renderTargetBlurBuffer2);
            renderer.clear();
            this.fsQuad.render(renderer);
            this.separableBlurMaterial2.uniforms["colorTexture"].value = this.renderTargetBlurBuffer2.texture;
            this.separableBlurMaterial2.uniforms["direction"].value = $3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionY;
            renderer.setRenderTarget(this.renderTargetEdgeBuffer2);
            renderer.clear();
            this.fsQuad.render(renderer);
            // Blend it additively over the input texture
            this.fsQuad.material = this.overlayMaterial;
            this.overlayMaterial.uniforms["maskTexture"].value = this.renderTargetMaskBuffer.texture;
            this.overlayMaterial.uniforms["edgeTexture1"].value = this.renderTargetEdgeBuffer1.texture;
            this.overlayMaterial.uniforms["edgeTexture2"].value = this.renderTargetEdgeBuffer2.texture;
            this.overlayMaterial.uniforms["patternTexture"].value = this.patternTexture;
            this.overlayMaterial.uniforms["edgeStrength"].value = this.edgeStrength;
            this.overlayMaterial.uniforms["edgeGlow"].value = this.edgeGlow;
            this.overlayMaterial.uniforms["usePatternTexture"].value = this.usePatternTexture;
            if (maskActive) renderer.state.buffers.stencil.setTest(true);
            renderer.setRenderTarget(readBuffer);
            this.fsQuad.render(renderer);
            renderer.setClearColor(this._oldClearColor, this.oldClearAlpha);
            renderer.autoClear = oldAutoClear;
        }
        if (this.renderToScreen) {
            this.fsQuad.material = this.materialCopy;
            this.copyUniforms["tDiffuse"].value = readBuffer.texture;
            renderer.setRenderTarget(null);
            this.fsQuad.render(renderer);
        }
    }
    getPrepareMaskMaterial() {
        return new (0, $ilwiq.ShaderMaterial)({
            uniforms: {
                "depthTexture": {
                    value: null
                },
                "cameraNearFar": {
                    value: new (0, $ilwiq.Vector2)(0.5, 0.5)
                },
                "textureMatrix": {
                    value: null
                }
            },
            vertexShader: `#include <morphtarget_pars_vertex>
				#include <skinning_pars_vertex>

				varying vec4 projTexCoord;
				varying vec4 vPosition;
				uniform mat4 textureMatrix;

				void main() {

					#include <skinbase_vertex>
					#include <begin_vertex>
					#include <morphtarget_vertex>
					#include <skinning_vertex>
					#include <project_vertex>

					vPosition = mvPosition;

					vec4 worldPosition = vec4( transformed, 1.0 );

					#ifdef USE_INSTANCING

						worldPosition = instanceMatrix * worldPosition;

					#endif
					
					worldPosition = modelMatrix * worldPosition;

					projTexCoord = textureMatrix * worldPosition;

				}`,
            fragmentShader: `#include <packing>
				varying vec4 vPosition;
				varying vec4 projTexCoord;
				uniform sampler2D depthTexture;
				uniform vec2 cameraNearFar;

				void main() {

					float depth = unpackRGBAToDepth(texture2DProj( depthTexture, projTexCoord ));
					float viewZ = - DEPTH_TO_VIEW_Z( depth, cameraNearFar.x, cameraNearFar.y );
					float depthTest = (-vPosition.z > viewZ) ? 1.0 : 0.0;
					gl_FragColor = vec4(0.0, depthTest, 1.0, 1.0);

				}`
        });
    }
    getEdgeDetectionMaterial() {
        return new (0, $ilwiq.ShaderMaterial)({
            uniforms: {
                "maskTexture": {
                    value: null
                },
                "texSize": {
                    value: new (0, $ilwiq.Vector2)(0.5, 0.5)
                },
                "visibleEdgeColor": {
                    value: new (0, $ilwiq.Vector3)(1.0, 1.0, 1.0)
                },
                "hiddenEdgeColor": {
                    value: new (0, $ilwiq.Vector3)(1.0, 1.0, 1.0)
                }
            },
            vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
            fragmentShader: `varying vec2 vUv;

				uniform sampler2D maskTexture;
				uniform vec2 texSize;
				uniform vec3 visibleEdgeColor;
				uniform vec3 hiddenEdgeColor;

				void main() {
					vec2 invSize = 1.0 / texSize;
					vec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);
					vec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);
					vec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);
					vec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);
					vec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);
					float diff1 = (c1.r - c2.r)*0.5;
					float diff2 = (c3.r - c4.r)*0.5;
					float d = length( vec2(diff1, diff2) );
					float a1 = min(c1.g, c2.g);
					float a2 = min(c3.g, c4.g);
					float visibilityFactor = min(a1, a2);
					vec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleEdgeColor : hiddenEdgeColor;
					gl_FragColor = vec4(edgeColor, 1.0) * vec4(d);
				}`
        });
    }
    getSeperableBlurMaterial(maxRadius) {
        return new (0, $ilwiq.ShaderMaterial)({
            defines: {
                "MAX_RADIUS": maxRadius
            },
            uniforms: {
                "colorTexture": {
                    value: null
                },
                "texSize": {
                    value: new (0, $ilwiq.Vector2)(0.5, 0.5)
                },
                "direction": {
                    value: new (0, $ilwiq.Vector2)(0.5, 0.5)
                },
                "kernelRadius": {
                    value: 1.0
                }
            },
            vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
            fragmentShader: `#include <common>
				varying vec2 vUv;
				uniform sampler2D colorTexture;
				uniform vec2 texSize;
				uniform vec2 direction;
				uniform float kernelRadius;

				float gaussianPdf(in float x, in float sigma) {
					return 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;
				}

				void main() {
					vec2 invSize = 1.0 / texSize;
					float sigma = kernelRadius/2.0;
					float weightSum = gaussianPdf(0.0, sigma);
					vec4 diffuseSum = texture2D( colorTexture, vUv) * weightSum;
					vec2 delta = direction * invSize * kernelRadius/float(MAX_RADIUS);
					vec2 uvOffset = delta;
					for( int i = 1; i <= MAX_RADIUS; i ++ ) {
						float x = kernelRadius * float(i) / float(MAX_RADIUS);
						float w = gaussianPdf(x, sigma);
						vec4 sample1 = texture2D( colorTexture, vUv + uvOffset);
						vec4 sample2 = texture2D( colorTexture, vUv - uvOffset);
						diffuseSum += ((sample1 + sample2) * w);
						weightSum += (2.0 * w);
						uvOffset += delta;
					}
					gl_FragColor = diffuseSum/weightSum;
				}`
        });
    }
    getOverlayMaterial() {
        return new (0, $ilwiq.ShaderMaterial)({
            uniforms: {
                "maskTexture": {
                    value: null
                },
                "edgeTexture1": {
                    value: null
                },
                "edgeTexture2": {
                    value: null
                },
                "patternTexture": {
                    value: null
                },
                "edgeStrength": {
                    value: 1.0
                },
                "edgeGlow": {
                    value: 1.0
                },
                "usePatternTexture": {
                    value: 0.0
                }
            },
            vertexShader: `varying vec2 vUv;

				void main() {
					vUv = uv;
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
				}`,
            fragmentShader: `varying vec2 vUv;

				uniform sampler2D maskTexture;
				uniform sampler2D edgeTexture1;
				uniform sampler2D edgeTexture2;
				uniform sampler2D patternTexture;
				uniform float edgeStrength;
				uniform float edgeGlow;
				uniform bool usePatternTexture;

				void main() {
					vec4 edgeValue1 = texture2D(edgeTexture1, vUv);
					vec4 edgeValue2 = texture2D(edgeTexture2, vUv);
					vec4 maskColor = texture2D(maskTexture, vUv);
					vec4 patternColor = texture2D(patternTexture, 6.0 * vUv);
					float visibilityFactor = 1.0 - maskColor.g > 0.0 ? 1.0 : 0.5;
					vec4 edgeValue = edgeValue1 + edgeValue2 * edgeGlow;
					vec4 finalColor = edgeStrength * maskColor.r * edgeValue;
					if(usePatternTexture)
						finalColor += + visibilityFactor * (1.0 - maskColor.r) * (1.0 - patternColor.r);
					gl_FragColor = finalColor;
				}`,
            blending: (0, $ilwiq.AdditiveBlending),
            depthTest: false,
            depthWrite: false,
            transparent: true
        });
    }
}
$3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionX = new (0, $ilwiq.Vector2)(1.0, 0.0);
$3b5dbdf1656506ea$export$356dcb7105dbd3ee.BlurDirectionY = new (0, $ilwiq.Vector2)(0.0, 1.0);



/**
 * Two pass Gaussian blur filter (horizontal and vertical blur shaders)
 * - see http://www.cake23.de/traveling-wavefronts-lit-up.html
 *
 * - 9 samples per pass
 * - standard deviation 2.7
 * - "h" and "v" parameters should be set to "1 / width" and "1 / height"
 */ const $651d56ec53f2d352$export$80bd9f7edd9f435 = {
    name: "HorizontalBlurShader",
    uniforms: {
        "tDiffuse": {
            value: null
        },
        "h": {
            value: 1.0 / 512.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform sampler2D tDiffuse;
		uniform float h;

		varying vec2 vUv;

		void main() {

			vec4 sum = vec4( 0.0 );

			sum += texture2D( tDiffuse, vec2( vUv.x - 4.0 * h, vUv.y ) ) * 0.051;
			sum += texture2D( tDiffuse, vec2( vUv.x - 3.0 * h, vUv.y ) ) * 0.0918;
			sum += texture2D( tDiffuse, vec2( vUv.x - 2.0 * h, vUv.y ) ) * 0.12245;
			sum += texture2D( tDiffuse, vec2( vUv.x - 1.0 * h, vUv.y ) ) * 0.1531;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;
			sum += texture2D( tDiffuse, vec2( vUv.x + 1.0 * h, vUv.y ) ) * 0.1531;
			sum += texture2D( tDiffuse, vec2( vUv.x + 2.0 * h, vUv.y ) ) * 0.12245;
			sum += texture2D( tDiffuse, vec2( vUv.x + 3.0 * h, vUv.y ) ) * 0.0918;
			sum += texture2D( tDiffuse, vec2( vUv.x + 4.0 * h, vUv.y ) ) * 0.051;

			gl_FragColor = sum;

		}`
};


/**
 * Two pass Gaussian blur filter (horizontal and vertical blur shaders)
 * - see http://www.cake23.de/traveling-wavefronts-lit-up.html
 *
 * - 9 samples per pass
 * - standard deviation 2.7
 * - "h" and "v" parameters should be set to "1 / width" and "1 / height"
 */ const $49a69b08c8e2030f$export$36776cbd03410684 = {
    name: "VerticalBlurShader",
    uniforms: {
        "tDiffuse": {
            value: null
        },
        "v": {
            value: 1.0 / 512.0
        }
    },
    vertexShader: /* glsl */ `

		varying vec2 vUv;

		void main() {

			vUv = uv;
			gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

		}`,
    fragmentShader: /* glsl */ `

		uniform sampler2D tDiffuse;
		uniform float v;

		varying vec2 vUv;

		void main() {

			vec4 sum = vec4( 0.0 );

			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 4.0 * v ) ) * 0.051;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 3.0 * v ) ) * 0.0918;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 2.0 * v ) ) * 0.12245;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y - 1.0 * v ) ) * 0.1531;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y ) ) * 0.1633;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 1.0 * v ) ) * 0.1531;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 2.0 * v ) ) * 0.12245;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 3.0 * v ) ) * 0.0918;
			sum += texture2D( tDiffuse, vec2( vUv.x, vUv.y + 4.0 * v ) ) * 0.051;

			gl_FragColor = sum;

		}`
};


var $459e1c1f3ae0104a$exports = {};
$459e1c1f3ae0104a$exports = new URL("0b.914eb0c8.png", import.meta.url).toString();


var $6d9b4d0cf952059b$exports = {};
$6d9b4d0cf952059b$exports = new URL("0l.63b0fd01.png", import.meta.url).toString();


var $d7a2be8a677f6e07$exports = {};
$d7a2be8a677f6e07$exports = new URL("0pa.2fa2a8a3.png", import.meta.url).toString();


var $a7365642b0006763$exports = {};
$a7365642b0006763$exports = new URL("0pi.7ff142dc.png", import.meta.url).toString();


var $1497fd5182446e01$exports = {};
$1497fd5182446e01$exports = new URL("0s.a30fcd21.png", import.meta.url).toString();


var $2e68099089d3ffd6$exports = {};
$2e68099089d3ffd6$exports = new URL("0t.608f359d.png", import.meta.url).toString();


var $a165f99da6bd21c2$exports = {};
$a165f99da6bd21c2$exports = new URL("1.5689592e.png", import.meta.url).toString();


var $9a2d7dabbc97fd96$exports = {};
$9a2d7dabbc97fd96$exports = new URL("1b.e5f99c8d.png", import.meta.url).toString();


var $1995b8d80c7eccd2$exports = {};
$1995b8d80c7eccd2$exports = new URL("1l.650f3cd1.png", import.meta.url).toString();


var $0a35d478929b2b30$exports = {};
$0a35d478929b2b30$exports = new URL("1pa.4f2f1922.png", import.meta.url).toString();


var $a4307a953c1fe049$exports = {};
$a4307a953c1fe049$exports = new URL("1pi.e2890185.png", import.meta.url).toString();


var $b85310145ebb8896$exports = {};
$b85310145ebb8896$exports = new URL("1t.9862eb09.png", import.meta.url).toString();


var $0be7d72854b0a88d$exports = {};
$0be7d72854b0a88d$exports = new URL("2.5f2e0f39.png", import.meta.url).toString();


var $db97517a25415a6b$exports = {};
$db97517a25415a6b$exports = new URL("3.142232ea.png", import.meta.url).toString();


var $1d80e32bc9c0b1b5$exports = {};
$1d80e32bc9c0b1b5$exports = new URL("4.d0e36cdd.png", import.meta.url).toString();


var $c26f4384c44ed64b$exports = {};
$c26f4384c44ed64b$exports = new URL("5.e99cfe39.png", import.meta.url).toString();


var $decd7d15e600d75d$var$matCaps = [
    {
        key: "0b",
        mat: new URL($459e1c1f3ae0104a$exports)
    },
    {
        key: "0l",
        mat: new URL($6d9b4d0cf952059b$exports)
    },
    {
        key: "0pa",
        mat: new URL($d7a2be8a677f6e07$exports)
    },
    {
        key: "0pi",
        mat: new URL($a7365642b0006763$exports)
    },
    {
        key: "0s",
        mat: new URL($1497fd5182446e01$exports)
    },
    {
        key: "0t",
        mat: new URL($2e68099089d3ffd6$exports)
    },
    {
        key: "1",
        mat: new URL($a165f99da6bd21c2$exports)
    },
    {
        key: "1b",
        mat: new URL($9a2d7dabbc97fd96$exports)
    },
    {
        key: "1l",
        mat: new URL($1995b8d80c7eccd2$exports)
    },
    {
        key: "1pa",
        mat: new URL($0a35d478929b2b30$exports)
    },
    {
        key: "1pi",
        mat: new URL($a4307a953c1fe049$exports)
    },
    {
        key: "1t",
        mat: new URL($b85310145ebb8896$exports)
    },
    {
        key: "2",
        mat: new URL($0be7d72854b0a88d$exports)
    },
    {
        key: "3",
        mat: new URL($db97517a25415a6b$exports)
    },
    {
        key: "4",
        mat: new URL($1d80e32bc9c0b1b5$exports)
    },
    {
        key: "5",
        mat: new URL($c26f4384c44ed64b$exports)
    }
];
/**
 * Base
 */ const $decd7d15e600d75d$var$aboutModal = document.querySelector(".modal-container");
$decd7d15e600d75d$var$aboutModal.addEventListener("click", (e)=>{
    gsap.to($decd7d15e600d75d$var$aboutButton, {
        opacity: 1,
        duration: 0.5,
        delay: 1
    });
    gsap.to($decd7d15e600d75d$var$aboutModal, {
        translateY: "110%",
        duration: 0.4,
        ease: "elastic.in(1, 1.1)"
    });
    gsap.to($decd7d15e600d75d$var$aboutModal, {
        opacity: 0,
        duration: 0.25,
        delay: 0.35
    });
    gsap.delayedCall(0.4, ()=>{
        $decd7d15e600d75d$var$aboutModal.style.display = "none";
    });
    $decd7d15e600d75d$var$aboutModal.style.pointerEvents = "none";
    $decd7d15e600d75d$var$pophigh.play();
    $decd7d15e600d75d$var$secretShowing = false;
    $decd7d15e600d75d$var$modalBlur($decd7d15e600d75d$var$secretShowing);
});
const $decd7d15e600d75d$var$aboutButton = document.querySelector(".about");
$decd7d15e600d75d$var$aboutButton.addEventListener("click", (e)=>{
    gsap.to($decd7d15e600d75d$var$aboutButton, {
        opacity: 0,
        duration: 0.15
    });
    gsap.to($decd7d15e600d75d$var$aboutModal, {
        translateY: "0%",
        duration: 0.65,
        ease: "elastic(1, 1.1)"
    });
    gsap.to($decd7d15e600d75d$var$aboutModal, {
        opacity: 1,
        duration: 0.1
    });
    $decd7d15e600d75d$var$aboutModal.style.pointerEvents = "all";
    $decd7d15e600d75d$var$aboutModal.style.display = "flex";
    $decd7d15e600d75d$var$boing.play();
    $decd7d15e600d75d$var$secretShowing = true;
    $decd7d15e600d75d$var$modalBlur($decd7d15e600d75d$var$secretShowing);
});
var $261a8110c08ab04d$exports = {};
$261a8110c08ab04d$exports = new URL("poplow.eed5497b.mp3", import.meta.url).toString();


// Canvas
let $decd7d15e600d75d$var$poplow = new Audio(new URL($261a8110c08ab04d$exports));
var $8cce55f79becde20$exports = {};
$8cce55f79becde20$exports = new URL("pophigh.5b35f8ed.mp3", import.meta.url).toString();


let $decd7d15e600d75d$var$pophigh = new Audio(new URL($8cce55f79becde20$exports));
var $b2bae1fbbff73f8b$exports = {};
$b2bae1fbbff73f8b$exports = new URL("boing.92429357.mp3", import.meta.url).toString();


let $decd7d15e600d75d$var$boing = new Audio(new URL($b2bae1fbbff73f8b$exports));
const $decd7d15e600d75d$var$canvas = document.querySelector("canvas.webgl");
// Scene
const $decd7d15e600d75d$var$scene = new $ilwiq.Scene();
const $decd7d15e600d75d$var$rootGroup = new $ilwiq.Group();
$decd7d15e600d75d$var$scene.add($decd7d15e600d75d$var$rootGroup);
const $decd7d15e600d75d$var$nonThemeGroup = new $ilwiq.Group();
$decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$nonThemeGroup);
// Params
if (localStorage.getItem("stuffleemakes-theme") == null) localStorage.setItem("stuffleemakes-theme", 0);
let $decd7d15e600d75d$var$casterObjects = [];
const $decd7d15e600d75d$var$themes = [
    {
        title: "0t",
        speaker: "0s",
        pattern: "0pi",
        waves: "0b",
        particle: "0pa",
        letter: "0l",
        bg: "#e8dde2",
        outline: "#ffe8fe"
    },
    {
        title: "2",
        speaker: "2",
        pattern: "2",
        pinata: "2",
        waves: "2",
        particle: "2",
        letter: "2",
        bg: "#111111",
        outline: "#797979"
    },
    {
        title: "4",
        speaker: "4",
        pattern: "4",
        pinata: "4",
        waves: "4",
        particle: "4",
        letter: "4",
        bg: "#dfdfdf",
        outline: "#fffde7"
    },
    {
        title: "5",
        speaker: "5",
        pattern: "5",
        pinata: "5",
        waves: "5",
        particle: "5",
        letter: "5",
        bg: "#c7d6e2",
        outline: "#b2ffff"
    }
];
const $decd7d15e600d75d$var$parameters = {
    fontName: "kaoly",
    fontSize: 0.5,
    curveSegments: 50,
    bevelDepth: 0.15,
    bevelThickness: 0.01,
    bevelSize: 0.01,
    bevelOffset: 0,
    theme: localStorage.getItem("stuffleemakes-theme"),
    currentTheme: $decd7d15e600d75d$var$themes[localStorage.getItem("stuffleemakes-theme")],
    testBG: "#000000",
    testOutline: "#ffffff",
    breakPoint: 500,
    isSmallScreen: false
};
const $decd7d15e600d75d$var$sizes = {
    width: window.innerWidth,
    height: window.innerHeight
};
const $decd7d15e600d75d$var$checkScreenSize = ()=>{
    $decd7d15e600d75d$var$parameters.isSmallScreen = $decd7d15e600d75d$var$sizes.width <= $decd7d15e600d75d$var$parameters.breakPoint;
};
$decd7d15e600d75d$var$checkScreenSize();
document.body.style.backgroundColor = $decd7d15e600d75d$var$parameters.currentTheme.bg;
/**
 * Loaders
 */ let $decd7d15e600d75d$var$loaded = false;
const $decd7d15e600d75d$var$loadingIndicator = document.querySelector(".loading-indicator");
const $decd7d15e600d75d$var$t = gsap.timeline({
    repeat: -1,
    repeatDelay: 0.5
});
$decd7d15e600d75d$var$t.to($decd7d15e600d75d$var$loadingIndicator, {
    scale: 0.75,
    duration: 1,
    ease: "elastic.out(0.65, 0.3)"
});
$decd7d15e600d75d$var$t.to($decd7d15e600d75d$var$loadingIndicator, {
    delay: 0.25,
    scale: 0.65,
    duration: 1,
    ease: "elastic.out(0.65, 0.3)"
});
const $decd7d15e600d75d$var$loadingManager = new $ilwiq.LoadingManager(()=>{
    if ($decd7d15e600d75d$var$loaded) return;
    $decd7d15e600d75d$var$updateThemeRing($decd7d15e600d75d$var$themeObjects[$decd7d15e600d75d$var$parameters.theme]);
    gsap.to($decd7d15e600d75d$var$loadingIndicator, {
        opacity: 0,
        duration: 0.5
    });
    gsap.to($decd7d15e600d75d$var$aboutButton, {
        opacity: 1,
        duration: 0.5,
        delay: 2.5
    });
    gsap.delayedCall(0.5, ()=>{
        gsap.to($decd7d15e600d75d$var$overlayMaterial.uniforms.uAlpha, {
            duration: 0.5,
            value: 0
        });
        $decd7d15e600d75d$var$fitCameraToCenteredObject($decd7d15e600d75d$var$camera, $decd7d15e600d75d$var$rootGroup, 1.1, null);
        gsap.delayedCall(2, ()=>{
            $decd7d15e600d75d$var$loaded = true;
        });
    });
});
// loadingManager.onError = function (url) {
//     console.log('There was an error loading ' + url);
// };
// loadingManager.onStart = function (url, itemsLoaded, itemsTotal) {
//     console.log('Started loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
// };
// loadingManager.onProgress = function (url, itemsLoaded, itemsTotal) {
//     console.log('Loading file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.');
// };
// Texture loader
let $decd7d15e600d75d$var$titleMaterial, $decd7d15e600d75d$var$speakerMaterial, $decd7d15e600d75d$var$patternsMaterial, $decd7d15e600d75d$var$pinataMaterial, $decd7d15e600d75d$var$wavesMaterial, $decd7d15e600d75d$var$particleMaterial, $decd7d15e600d75d$var$letterMaterial, $decd7d15e600d75d$var$pastelMaterial, $decd7d15e600d75d$var$murderMaterial, $decd7d15e600d75d$var$boneMaterial, $decd7d15e600d75d$var$funMaterial, $decd7d15e600d75d$var$titleTexture, $decd7d15e600d75d$var$speakerTexture, $decd7d15e600d75d$var$patternsTexture, $decd7d15e600d75d$var$pinataTexture, $decd7d15e600d75d$var$wavesTexture, $decd7d15e600d75d$var$particleTexture, $decd7d15e600d75d$var$letterTexture;
const $decd7d15e600d75d$var$textureLoader = new $ilwiq.TextureLoader($decd7d15e600d75d$var$loadingManager);
const $decd7d15e600d75d$var$loadTextures = ()=>{
    if ($decd7d15e600d75d$var$titleTexture) {
        $decd7d15e600d75d$var$titleTexture.dispose();
        $decd7d15e600d75d$var$titleMaterial.dispose();
        $decd7d15e600d75d$var$titleMesh.material.matcap.dispose();
        $decd7d15e600d75d$var$titleMesh.material.dispose();
        $decd7d15e600d75d$var$speakerTexture.dispose();
        $decd7d15e600d75d$var$speakerMaterial.dispose();
        $decd7d15e600d75d$var$patternsTexture.dispose();
        $decd7d15e600d75d$var$patternsMaterial.dispose();
        $decd7d15e600d75d$var$linkSpeaker.material.matcap.dispose();
        $decd7d15e600d75d$var$linkSpeaker.material.dispose();
        // pinataTexture.dispose()
        // pinataMaterial.dispose()
        // linkPinata.material.matcap.dispose()
        // linkPinata.material.dispose()
        $decd7d15e600d75d$var$wavesTexture.dispose();
        $decd7d15e600d75d$var$wavesMaterial.dispose();
        $decd7d15e600d75d$var$linkWaves.material.matcap.dispose();
        $decd7d15e600d75d$var$linkWaves.material.dispose();
        $decd7d15e600d75d$var$particleTexture.dispose();
        $decd7d15e600d75d$var$particleMaterial.dispose();
        $decd7d15e600d75d$var$linkParticles.material.matcap.dispose();
        $decd7d15e600d75d$var$linkParticles.material.dispose();
        $decd7d15e600d75d$var$letterTexture.dispose();
        $decd7d15e600d75d$var$letterMaterial.dispose();
        $decd7d15e600d75d$var$linkText.material.matcap.dispose();
        $decd7d15e600d75d$var$linkText.material.dispose();
    }
    $decd7d15e600d75d$var$titleTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.title;
    })[0].mat);
    $decd7d15e600d75d$var$titleMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$titleTexture
    });
    $decd7d15e600d75d$var$speakerTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.speaker;
    })[0].mat);
    $decd7d15e600d75d$var$speakerMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$speakerTexture
    });
    $decd7d15e600d75d$var$patternsTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.pattern;
    })[0].mat);
    $decd7d15e600d75d$var$patternsMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$patternsTexture
    });
    // pinataTexture = textureLoader.load('assets/matcaps/' + parameters.currentTheme.pinata + '.png')
    // pinataMaterial = new THREE.MeshMatcapMaterial({matcap:pinataTexture})
    $decd7d15e600d75d$var$wavesTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.waves;
    })[0].mat);
    $decd7d15e600d75d$var$wavesMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$wavesTexture
    });
    $decd7d15e600d75d$var$particleTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.particle;
    })[0].mat);
    $decd7d15e600d75d$var$particleMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$particleTexture
    });
    $decd7d15e600d75d$var$letterTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == $decd7d15e600d75d$var$parameters.currentTheme.letter;
    })[0].mat);
    $decd7d15e600d75d$var$letterMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: $decd7d15e600d75d$var$letterTexture
    });
};
const $decd7d15e600d75d$var$reSetTextures = ()=>{
    $decd7d15e600d75d$var$loadTextures();
    $decd7d15e600d75d$var$linkWaves.material = $decd7d15e600d75d$var$wavesMaterial;
    // linkPinata.material = pinataMaterial
    $decd7d15e600d75d$var$linkParticles.material = $decd7d15e600d75d$var$particleMaterial;
    $decd7d15e600d75d$var$linkPatterns.material = $decd7d15e600d75d$var$patternsMaterial;
    $decd7d15e600d75d$var$linkSpeaker.material = $decd7d15e600d75d$var$speakerMaterial;
    $decd7d15e600d75d$var$linkText.material = $decd7d15e600d75d$var$letterMaterial;
    $decd7d15e600d75d$var$titleMesh.material = $decd7d15e600d75d$var$titleMaterial;
};
$decd7d15e600d75d$var$loadTextures();
let $decd7d15e600d75d$var$linkText, $decd7d15e600d75d$var$linkSpeaker, $decd7d15e600d75d$var$linkPinata, $decd7d15e600d75d$var$linkWaves, $decd7d15e600d75d$var$linkParticles, $decd7d15e600d75d$var$linkPatterns;
const $decd7d15e600d75d$var$gltfLoader = new (0, $7lx9d.GLTFLoader)($decd7d15e600d75d$var$loadingManager);
let $decd7d15e600d75d$var$titleMesh;
const $decd7d15e600d75d$var$fontLoader = new (0, $eT66s.FontLoader)($decd7d15e600d75d$var$loadingManager);
var $f50badcaf407a646$exports = {};
$f50badcaf407a646$exports = new URL("speaker.20e5ad03.glb", import.meta.url).toString();


var $d3b2b85ba1a1eb2d$exports = {};
$d3b2b85ba1a1eb2d$exports = new URL("pattern.3023fd2d.glb", import.meta.url).toString();


var $537fcc2eeb1d8b3e$exports = {};
$537fcc2eeb1d8b3e$exports = new URL("waves.15dc2590.glb", import.meta.url).toString();


var $0c762b1b4f87eece$exports = {};
$0c762b1b4f87eece$exports = new URL("particles.8d1cc640.glb", import.meta.url).toString();


const $decd7d15e600d75d$var$loadEverythingElse = ()=>{
    const yOffset = $decd7d15e600d75d$var$titleMesh.position.y;
    $decd7d15e600d75d$var$gltfLoader.load(new URL($f50badcaf407a646$exports).href, (gltf)=>{
        $decd7d15e600d75d$var$linkSpeaker = gltf.scene.children[0];
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$linkSpeaker);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) $decd7d15e600d75d$var$linkSpeaker.position.set(-0.45, yOffset + -1.8, 0);
        else $decd7d15e600d75d$var$linkSpeaker.position.set(-2.25, yOffset + 0.8, 0);
        $decd7d15e600d75d$var$linkSpeaker.rotation.x = -Math.PI * 0.1;
        $decd7d15e600d75d$var$linkSpeaker.scale.set(0.13, 0.13, 0.13);
        $decd7d15e600d75d$var$linkSpeaker.material = $decd7d15e600d75d$var$speakerMaterial;
        $decd7d15e600d75d$var$linkSpeaker.name = "linkSpeaker";
        $decd7d15e600d75d$var$linkSpeaker.userData.s = 0.13;
        // linkSpeaker.userData.u = 'https://stuffleemakes.com/viz/'
        $decd7d15e600d75d$var$linkSpeaker.userData.u = "audio.html";
        $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$linkSpeaker);
    });
    $decd7d15e600d75d$var$gltfLoader.load(new URL($d3b2b85ba1a1eb2d$exports).href, (gltf)=>{
        $decd7d15e600d75d$var$linkPatterns = gltf.scene.children[0];
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$linkPatterns);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) $decd7d15e600d75d$var$linkPatterns.position.set(-0.375, yOffset + -0.9, 0);
        else $decd7d15e600d75d$var$linkPatterns.position.set(-1.15, yOffset + 0.85, 0);
        $decd7d15e600d75d$var$linkPatterns.rotation.z = -Math.PI * 0.1;
        $decd7d15e600d75d$var$linkPatterns.scale.set(0.14, 0.14, 0.1);
        $decd7d15e600d75d$var$linkPatterns.material = $decd7d15e600d75d$var$patternsMaterial;
        $decd7d15e600d75d$var$linkPatterns.name = "linkPatterns";
        $decd7d15e600d75d$var$linkPatterns.userData.s = 0.13;
        $decd7d15e600d75d$var$linkPatterns.userData.u = "patterns-v2.html";
        $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$linkPatterns);
    });
    $decd7d15e600d75d$var$fontLoader.load("gentilis_regular.typeface.json", (font)=>{
        const geometry = new (0, $8NFZ6.TextGeometry)("T", {
            font: font,
            size: 0.575,
            height: 0.1,
            curveSegments: 16,
            bevelEnabled: false,
            bevelThickness: 0.01,
            bevelSize: 0.01,
            bevelOffset: 0
        });
        geometry.center();
        $decd7d15e600d75d$var$linkText = new $ilwiq.Mesh(geometry, $decd7d15e600d75d$var$letterMaterial);
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$linkText);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) {
            $decd7d15e600d75d$var$linkText.position.set(0, yOffset + -2.5, 0);
            $decd7d15e600d75d$var$linkText.scale.set(1.075, 1.075, 1.075);
        } else $decd7d15e600d75d$var$linkText.position.set(0, yOffset + 0.825, 0);
        $decd7d15e600d75d$var$linkText.name = "linkText";
        $decd7d15e600d75d$var$linkText.userData.s = 1;
        $decd7d15e600d75d$var$linkText.userData.u = "typography-sampling.html";
        $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$linkText);
    });
    $decd7d15e600d75d$var$gltfLoader.load(new URL($537fcc2eeb1d8b3e$exports).href, (gltf)=>{
        $decd7d15e600d75d$var$linkWaves = gltf.scene.children[0];
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$linkWaves);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) {
            $decd7d15e600d75d$var$linkWaves.position.set(0.5, yOffset + -1.8, 0);
            $decd7d15e600d75d$var$linkWaves.scale.set(0.9, 0.9, 0.9);
        } else $decd7d15e600d75d$var$linkWaves.position.set(1.15, yOffset + 0.84, 0);
        $decd7d15e600d75d$var$linkWaves.rotation.x = -Math.PI * 0.2;
        $decd7d15e600d75d$var$linkWaves.scale.set(0.315, 0.315, 0.315);
        $decd7d15e600d75d$var$linkWaves.material = $decd7d15e600d75d$var$wavesMaterial;
        $decd7d15e600d75d$var$linkWaves.name = "linkWaves";
        $decd7d15e600d75d$var$linkWaves.userData.s = 0.315;
        $decd7d15e600d75d$var$linkWaves.userData.u = "shaders-wave.html";
        $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$linkWaves);
    });
    // gltfLoader.load(
    //     'assets/models/pinata.glb',
    //     (gltf) =>
    //     {
    //         linkPinata = gltf.scene.children[0]
    //         nonThemeGroup.add(linkPinata)
    //         if(parameters.isSmallScreen) {
    //             linkPinata.position.set(0,yOffset + -2.85,0)
    //         }
    //         else {
    //             linkPinata.position.set(0,yOffset + 0.8,0)
    //         }
    //         linkPinata.scale.set(0.155,0.155,0.155)
    //         linkPinata.material = pinataMaterial
    //         linkPinata.name = 'linkPinata'
    //         linkPinata.userData.s = 0.155
    //         linkPinata.userData.u = 'https://poopypinata.com'
    //         casterObjects.push(linkPinata)
    //     }
    // )
    $decd7d15e600d75d$var$gltfLoader.load(new URL($0c762b1b4f87eece$exports).href, (gltf)=>{
        $decd7d15e600d75d$var$linkParticles = gltf.scene.children[0];
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$linkParticles);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) $decd7d15e600d75d$var$linkParticles.position.set(0.525, yOffset - 0.9, 0);
        else $decd7d15e600d75d$var$linkParticles.position.set(2.25, yOffset + 0.9, 0);
        $decd7d15e600d75d$var$linkParticles.scale.set(0.075, 0.075, 0.075);
        $decd7d15e600d75d$var$linkParticles.material = $decd7d15e600d75d$var$particleMaterial;
        $decd7d15e600d75d$var$linkParticles.name = "linkParticles";
        $decd7d15e600d75d$var$linkParticles.userData.s = 0.075;
        $decd7d15e600d75d$var$linkParticles.userData.u = "particles.html";
        $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$linkParticles);
    });
};

var $9175c6fc81c16ba9$exports = {};
$9175c6fc81c16ba9$exports = new URL("desktop.a16d3532.glb", import.meta.url).toString();


const $decd7d15e600d75d$var$buildText = ()=>{
    $decd7d15e600d75d$var$checkScreenSize();
    var item = $decd7d15e600d75d$var$parameters.isSmallScreen ? new URL((parcelRequire("3YnPA"))) : new URL($9175c6fc81c16ba9$exports);
    $decd7d15e600d75d$var$gltfLoader.load(item.href, (gltf)=>{
        $decd7d15e600d75d$var$titleMesh = gltf.scene.children[0];
        $decd7d15e600d75d$var$nonThemeGroup.add($decd7d15e600d75d$var$titleMesh);
        if ($decd7d15e600d75d$var$parameters.isSmallScreen) $decd7d15e600d75d$var$titleMesh.position.y = 1.4;
        $decd7d15e600d75d$var$titleMesh.scale.set(1.1, 1.1, 1.1);
        $decd7d15e600d75d$var$titleMesh.material = $decd7d15e600d75d$var$titleMaterial;
        $decd7d15e600d75d$var$loadEverythingElse();
        $decd7d15e600d75d$var$setupThemePicker();
    });
};
/**
 * Theme picker
 */ let $decd7d15e600d75d$var$pastelMesh, $decd7d15e600d75d$var$murderMesh, $decd7d15e600d75d$var$boneMesh, $decd7d15e600d75d$var$funMesh, $decd7d15e600d75d$var$ringMesh;
let $decd7d15e600d75d$var$themeObjects = [];
const $decd7d15e600d75d$var$setupThemePicker = ()=>{
    const pastelTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == "0t";
    })[0].mat);
    $decd7d15e600d75d$var$pastelMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: pastelTexture
    });
    $decd7d15e600d75d$var$pastelMaterial.side = $ilwiq.DoubleSide;
    const murderTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == "2";
    })[0].mat);
    $decd7d15e600d75d$var$murderMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: murderTexture
    });
    $decd7d15e600d75d$var$murderMaterial.side = $ilwiq.DoubleSide;
    const boneTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == "4";
    })[0].mat);
    $decd7d15e600d75d$var$boneMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: boneTexture
    });
    $decd7d15e600d75d$var$boneMaterial.side = $ilwiq.DoubleSide;
    const funTexture = $decd7d15e600d75d$var$textureLoader.load($decd7d15e600d75d$var$matCaps.filter((obj)=>{
        return obj.key == "5";
    })[0].mat);
    $decd7d15e600d75d$var$funMaterial = new $ilwiq.MeshMatcapMaterial({
        matcap: funTexture
    });
    $decd7d15e600d75d$var$funMaterial.side = $ilwiq.DoubleSide;
    const offset = {
        x: $decd7d15e600d75d$var$parameters.isSmallScreen ? -0.4 : 1.9,
        y: $decd7d15e600d75d$var$parameters.isSmallScreen ? -1.75 : -0.35,
        s: 0.3
    };
    const geometry = new $ilwiq.SphereGeometry(0.08, 16, 16);
    $decd7d15e600d75d$var$pastelMesh = new $ilwiq.Mesh(geometry, $decd7d15e600d75d$var$pastelMaterial);
    $decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$pastelMesh);
    $decd7d15e600d75d$var$pastelMesh.position.set(offset.x, offset.y, 0);
    $decd7d15e600d75d$var$murderMesh = new $ilwiq.Mesh(geometry, $decd7d15e600d75d$var$murderMaterial);
    $decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$murderMesh);
    $decd7d15e600d75d$var$murderMesh.position.set(offset.x + offset.s, offset.y, 0);
    $decd7d15e600d75d$var$boneMesh = new $ilwiq.Mesh(geometry, $decd7d15e600d75d$var$boneMaterial);
    $decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$boneMesh);
    $decd7d15e600d75d$var$boneMesh.position.set(offset.x + offset.s * 2, offset.y, 0);
    $decd7d15e600d75d$var$funMesh = new $ilwiq.Mesh(geometry, $decd7d15e600d75d$var$funMaterial);
    $decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$funMesh);
    $decd7d15e600d75d$var$funMesh.position.set(offset.x + offset.s * 3, offset.y, 0);
    const rgeometry = new $ilwiq.RingGeometry(0.1, 0.12, 64);
    $decd7d15e600d75d$var$ringMesh = new $ilwiq.Mesh(rgeometry, $decd7d15e600d75d$var$pastelMaterial);
    $decd7d15e600d75d$var$rootGroup.add($decd7d15e600d75d$var$ringMesh);
    $decd7d15e600d75d$var$ringMesh.position.set(offset.x, offset.y, 0);
    $decd7d15e600d75d$var$pastelMesh.name = "theme0";
    $decd7d15e600d75d$var$pastelMesh.userData.s = 1;
    $decd7d15e600d75d$var$murderMesh.name = "theme1";
    $decd7d15e600d75d$var$murderMesh.userData.s = 1;
    $decd7d15e600d75d$var$boneMesh.name = "theme2";
    $decd7d15e600d75d$var$boneMesh.userData.s = 1;
    $decd7d15e600d75d$var$funMesh.name = "theme3";
    $decd7d15e600d75d$var$funMesh.userData.s = 1;
    $decd7d15e600d75d$var$themeObjects.push($decd7d15e600d75d$var$pastelMesh);
    $decd7d15e600d75d$var$themeObjects.push($decd7d15e600d75d$var$murderMesh);
    $decd7d15e600d75d$var$themeObjects.push($decd7d15e600d75d$var$boneMesh);
    $decd7d15e600d75d$var$themeObjects.push($decd7d15e600d75d$var$funMesh);
    if ($decd7d15e600d75d$var$parameters.theme != 0) $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$pastelMesh);
    if ($decd7d15e600d75d$var$parameters.theme != 1) $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$murderMesh);
    if ($decd7d15e600d75d$var$parameters.theme != 2) $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$boneMesh);
    if ($decd7d15e600d75d$var$parameters.theme != 3) $decd7d15e600d75d$var$casterObjects.push($decd7d15e600d75d$var$funMesh);
    const gsTimeline = gsap.timeline({
        repeat: -1
    });
    gsTimeline.to($decd7d15e600d75d$var$ringMesh.rotation, {
        y: Math.PI,
        duration: 2,
        ease: "elastic.inOut",
        delay: 3
    });
};
const $decd7d15e600d75d$var$updateThemeRing = (o)=>{
    if (!$decd7d15e600d75d$var$ringMesh) return;
    $decd7d15e600d75d$var$ringMesh.material = o.material;
    $decd7d15e600d75d$var$ringMesh.position.x = o.position.x;
    $decd7d15e600d75d$var$ringMesh.position.y = o.position.y;
};
$decd7d15e600d75d$var$buildText();
const $decd7d15e600d75d$var$fitCameraToCenteredObject = function(camera, object, offset, orbitControls) {
    const boundingBox = new $ilwiq.Box3();
    boundingBox.setFromObject(object);
    var size = new $ilwiq.Vector3();
    boundingBox.getSize(size);
    const fov = camera.fov * (Math.PI / 180);
    const fovh = 2 * Math.atan(Math.tan(fov / 2) * camera.aspect);
    let dx = size.z / 2 + Math.abs(size.x / 2 / Math.tan(fovh / 2));
    let dy = size.z / 2 + Math.abs(size.y / 2 / Math.tan(fov / 2));
    let cameraZ = Math.max(dx, dy);
    // offset the camera, if desired (to avoid filling the whole canvas)
    if (offset !== undefined && offset !== 0) cameraZ *= offset;
    const ftl = gsap.timeline();
    ftl.to(camera.position, {
        x: 0,
        duration: 1.5,
        ease: "elastic.out(1, 0.6)",
        delay: 0.5
    }).to(camera.position, {
        y: 0,
        duration: 1.5,
        ease: "elastic.out(1, 0.6)",
        delay: 0.5
    }, 0).to(camera.position, {
        z: cameraZ,
        duration: 1.5,
        ease: "elastic.out(1, 0.6)",
        delay: 0.5
    }, 0);
    gsap.delayedCall(2, ()=>{
        camera.far = 500;
        camera.updateProjectionMatrix();
        $decd7d15e600d75d$var$applyDistanceBlur();
    });
    // set the far plane of the camera so that it easily encompasses the whole object
    const minZ = boundingBox.min.z;
    const cameraToFarEdge = minZ < 0 ? -minZ + cameraZ : cameraZ - minZ;
    camera.far = cameraToFarEdge * 3;
    camera.updateProjectionMatrix();
    $decd7d15e600d75d$var$minDistance = cameraZ;
    const v = new (0, $ilwiq.Vector3)(1, 1, 1).unproject(camera);
    $decd7d15e600d75d$var$maxDistance = v.distanceTo($decd7d15e600d75d$var$rootGroup.position);
    $decd7d15e600d75d$var$minDistance = cameraZ + $decd7d15e600d75d$var$maxDistance * 0.2;
    $decd7d15e600d75d$var$applyDistanceBlur();
    if (orbitControls) {
        // set camera to rotate around the center
        orbitControls.target = new $ilwiq.Vector3(0, 0, 0);
        // prevent camera from zooming out far enough to create far plane cutoff
        orbitControls.maxDistance = cameraToFarEdge * 2;
    }
};
/**
 * Overlay
 */ const $decd7d15e600d75d$var$overlayGeometry = new $ilwiq.PlaneGeometry(2.0, 2.0, 1.0);
const $decd7d15e600d75d$var$overlayMaterial = new $ilwiq.ShaderMaterial({
    transparent: true,
    depthWrite: false,
    vertexShader: `
         void main() {
             gl_Position = vec4(position, 1.0);
         }
     `,
    fragmentShader: `
         uniform float uAlpha;
         uniform vec3 uColor;
         void main() {
             gl_FragColor = vec4(uColor, uAlpha);
         }
     `,
    uniforms: {
        uAlpha: {
            value: 1
        },
        uColor: {
            value: new $ilwiq.Color($decd7d15e600d75d$var$parameters.currentTheme.bg)
        }
    }
});
const $decd7d15e600d75d$var$overlay = new $ilwiq.Mesh($decd7d15e600d75d$var$overlayGeometry, $decd7d15e600d75d$var$overlayMaterial);
$decd7d15e600d75d$var$scene.add($decd7d15e600d75d$var$overlay);
window.addEventListener("resize", ()=>{
    const oldW = $decd7d15e600d75d$var$sizes.width;
    const oldH = $decd7d15e600d75d$var$sizes.height;
    // Update sizes
    $decd7d15e600d75d$var$sizes.width = window.innerWidth;
    $decd7d15e600d75d$var$sizes.height = window.innerHeight;
    // Update camera
    $decd7d15e600d75d$var$camera.aspect = $decd7d15e600d75d$var$sizes.width / $decd7d15e600d75d$var$sizes.height;
    $decd7d15e600d75d$var$camera.updateProjectionMatrix();
    // Update renderer
    $decd7d15e600d75d$var$renderer.setSize($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height);
    $decd7d15e600d75d$var$renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    $decd7d15e600d75d$var$composer.setSize($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height);
    $decd7d15e600d75d$var$composer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    $decd7d15e600d75d$var$outlinePass.resolution = new $ilwiq.Vector2($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height);
// fxaaPass.uniforms.resolution.value.x = 1/(sizes.width*renderer.pixelRatio)
// fxaaPass.uniforms.resolution.value.y = 1/(sizes.height*renderer.pixelRatio)
});
const $decd7d15e600d75d$var$raycaster = new $ilwiq.Raycaster();
const $decd7d15e600d75d$var$mouse = new $ilwiq.Vector2();
window.addEventListener("pointermove", (e)=>{
    if (e.isPrimary === false) return;
    if (!$decd7d15e600d75d$var$loaded) return;
    if ($decd7d15e600d75d$var$secretShowing) return;
    $decd7d15e600d75d$var$mouse.x = e.clientX / window.innerWidth * 2 - 1;
    $decd7d15e600d75d$var$mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
    $decd7d15e600d75d$var$checkIntersection();
    //exponential falloff
    // let x = (cameraHorzLimit/Math.pow(2, cameraHorzLimit - Math.abs(x))) * Math.sign(mouse.x)
    // camera.position.x = cameraHorzLimit * mouse.x
    // camera.position.y = cameraVertLimit * mouse.y
    $decd7d15e600d75d$var$camera.position.lerp(new $ilwiq.Vector3($decd7d15e600d75d$var$cameraHorzLimit * $decd7d15e600d75d$var$mouse.x, $decd7d15e600d75d$var$cameraVertLimit * $decd7d15e600d75d$var$mouse.y, $decd7d15e600d75d$var$camera.position.z), 0.25);
    if ($decd7d15e600d75d$var$titleMesh) $decd7d15e600d75d$var$applyDistanceBlur();
});
const $decd7d15e600d75d$var$addSelectedObject = (object)=>{
    $decd7d15e600d75d$var$outlinePass.selectedObjects = [];
    if (object) $decd7d15e600d75d$var$outlinePass.selectedObjects.push(object);
};
const $decd7d15e600d75d$var$checkIntersection = ()=>{
    if (!$decd7d15e600d75d$var$loaded) return;
    $decd7d15e600d75d$var$raycaster.setFromCamera($decd7d15e600d75d$var$mouse, $decd7d15e600d75d$var$camera);
    const intersects = $decd7d15e600d75d$var$raycaster.intersectObjects($decd7d15e600d75d$var$casterObjects, true);
    if (intersects.length > 0) {
        if ($decd7d15e600d75d$var$outlinePass.selectedObjects.length == 0 || $decd7d15e600d75d$var$outlinePass.selectedObjects[0].name != $decd7d15e600d75d$var$outlinePass.selectedObjects[0].name) {
            if ($decd7d15e600d75d$var$outlinePass.selectedObjects.length > 0) $decd7d15e600d75d$var$setObjectNotHovered($decd7d15e600d75d$var$outlinePass.selectedObjects[0]);
            $decd7d15e600d75d$var$addSelectedObject(intersects[0].object);
            $decd7d15e600d75d$var$setObjectHovered($decd7d15e600d75d$var$outlinePass.selectedObjects[0]);
            document.body.style.cursor = "pointer";
            $decd7d15e600d75d$var$poplow.play();
        }
    } else {
        if ($decd7d15e600d75d$var$outlinePass.selectedObjects.length > 0) $decd7d15e600d75d$var$setObjectNotHovered($decd7d15e600d75d$var$outlinePass.selectedObjects[0]);
        $decd7d15e600d75d$var$addSelectedObject();
        document.body.style.cursor = "default";
    }
};
let $decd7d15e600d75d$var$mouseIsDown = false;
window.addEventListener("pointerdown", ()=>{
    $decd7d15e600d75d$var$mouseIsDown = true;
});
window.addEventListener("pointerup", ()=>{
    $decd7d15e600d75d$var$mouseIsDown = false;
});
$decd7d15e600d75d$var$canvas.addEventListener("pointerenter", (e)=>{
    $decd7d15e600d75d$var$mouse.x = e.clientX / window.innerWidth * 2 - 1;
    $decd7d15e600d75d$var$mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
});
const $decd7d15e600d75d$var$tryFunc = (func)=>{
    if ($decd7d15e600d75d$var$mouseIsDown) setTimeout(()=>{
        if (!$decd7d15e600d75d$var$mouseIsDown) func();
    }, 100);
    else func();
};
window.addEventListener("click", (e)=>{
    $decd7d15e600d75d$var$mouse.x = e.clientX / window.innerWidth * 2 - 1;
    $decd7d15e600d75d$var$mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
    $decd7d15e600d75d$var$checkIntersection();
    if ($decd7d15e600d75d$var$outlinePass.selectedObjects.length == 0) return;
    const obj = $decd7d15e600d75d$var$outlinePass.selectedObjects[0];
    const name = obj.name;
    if (name.startsWith("theme")) {
        const index = parseInt(name.substr(-1));
        localStorage.setItem("stuffleemakes-theme", index);
        $decd7d15e600d75d$var$casterObjects = $decd7d15e600d75d$var$casterObjects.filter((e)=>{
            return !e.name.startsWith("theme");
        });
        const filteredThemes = $decd7d15e600d75d$var$themeObjects.filter((e)=>{
            return e.name != name;
        });
        $decd7d15e600d75d$var$casterObjects = $decd7d15e600d75d$var$casterObjects.concat(filteredThemes);
        const oldColor = $decd7d15e600d75d$var$parameters.currentTheme.bg;
        $decd7d15e600d75d$var$parameters.theme = index;
        $decd7d15e600d75d$var$parameters.currentTheme = $decd7d15e600d75d$var$themes[$decd7d15e600d75d$var$parameters.theme];
        const newColor = $decd7d15e600d75d$var$parameters.currentTheme.bg;
        const speed = 0.15;
        gsap.delayedCall(speed, ()=>{
            $decd7d15e600d75d$var$reSetTextures();
            $decd7d15e600d75d$var$parameters.testBG = $decd7d15e600d75d$var$parameters.currentTheme.bg;
            $decd7d15e600d75d$var$parameters.testOutline = $decd7d15e600d75d$var$parameters.currentTheme.outline;
            $decd7d15e600d75d$var$outlinePass.visibleEdgeColor.set($decd7d15e600d75d$var$parameters.currentTheme.outline);
            $decd7d15e600d75d$var$outlinePass.hiddenEdgeColor.set($decd7d15e600d75d$var$parameters.currentTheme.outline);
            $decd7d15e600d75d$var$updateThemeRing(obj);
        });
        const gtl = gsap.timeline();
        gtl.to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            x: 0,
            duration: speed
        }).to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            y: 0,
            duration: speed
        }, 0).to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            z: 0,
            duration: speed
        }, 0).to($decd7d15e600d75d$var$nonThemeGroup.rotation, {
            x: Math.PI * -0.5,
            duration: speed
        }, 0).to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            x: 1,
            duration: 0.75,
            ease: "elastic.out(1, 0.6)"
        }, speed).to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            y: 1,
            duration: 0.75,
            ease: "elastic.out(1, 0.6)"
        }, speed).to($decd7d15e600d75d$var$nonThemeGroup.scale, {
            z: 1,
            duration: 0.75,
            ease: "elastic.out(1, 0.6)"
        }, speed).to($decd7d15e600d75d$var$nonThemeGroup.rotation, {
            x: 0,
            duration: 0.75,
            ease: "elastic.out(1, 0.6)"
        }, speed).fromTo($decd7d15e600d75d$var$parameters.currentTheme, {
            bg: oldColor
        }, {
            bg: newColor,
            duration: speed * 4,
            onUpdate: function() {
                $decd7d15e600d75d$var$renderer.setClearColor($decd7d15e600d75d$var$parameters.currentTheme.bg);
            }
        }, speed);
        $decd7d15e600d75d$var$boing.play();
    } else {
        gsap.delayedCall(0.25, ()=>{
            window.location.href = obj.userData.u;
        });
        $decd7d15e600d75d$var$pophigh.play();
    }
    $decd7d15e600d75d$var$setObjectNotHovered(obj);
    $decd7d15e600d75d$var$addSelectedObject();
});
let $decd7d15e600d75d$var$gsHover;
const $decd7d15e600d75d$var$setObjectHovered = (o)=>{
    $decd7d15e600d75d$var$gsHover = gsap.timeline();
    $decd7d15e600d75d$var$gsHover.to(o.scale, {
        x: o.userData.s + o.userData.s * 0.3,
        duration: 0.65,
        ease: "elastic(1, 0.4)"
    }).to(o.scale, {
        y: o.userData.s + o.userData.s * 0.3,
        duration: 0.65,
        ease: "elastic(1, 0.4)"
    }, 0).to(o.scale, {
        z: o.userData.s + o.userData.s * 0.3,
        duration: 0.65,
        ease: "elastic(1, 0.4)"
    }, 0);
};
const $decd7d15e600d75d$var$setObjectNotHovered = (o)=>{
    $decd7d15e600d75d$var$gsHover = gsap.timeline();
    $decd7d15e600d75d$var$gsHover.to(o.scale, {
        x: o.userData.s,
        duration: 0.65,
        ease: "elastic(1, 0.2)"
    }).to(o.scale, {
        y: o.userData.s,
        duration: 0.65,
        ease: "elastic(1, 0.2)"
    }, 0).to(o.scale, {
        z: o.userData.s,
        duration: 0.65,
        ease: "elastic(1, 0.2)"
    }, 0);
};
/**
 * Camera
 */ // Base camera
let $decd7d15e600d75d$var$cameraHorzLimit = 11;
let $decd7d15e600d75d$var$cameraVertLimit = 11;
let $decd7d15e600d75d$var$minDistance = -1;
let $decd7d15e600d75d$var$maxDistance = -1;
const $decd7d15e600d75d$var$camera = new $ilwiq.PerspectiveCamera(45, $decd7d15e600d75d$var$sizes.width / $decd7d15e600d75d$var$sizes.height, 0.1, 100);
$decd7d15e600d75d$var$camera.position.set((Math.random() - 1) * 5, (Math.random() - 1) * 5, Math.random() * 10 + $decd7d15e600d75d$var$cameraHorzLimit + 5);
$decd7d15e600d75d$var$camera.lookAt($decd7d15e600d75d$var$rootGroup.position);
$decd7d15e600d75d$var$scene.add($decd7d15e600d75d$var$camera);
/**
 * Renderer
 */ const $decd7d15e600d75d$var$renderer = new $ilwiq.WebGLRenderer({
    canvas: $decd7d15e600d75d$var$canvas,
    alpha: true
});
$decd7d15e600d75d$var$renderer.outputEncoding = $ilwiq.sRGBEncoding;
$decd7d15e600d75d$var$renderer.setSize($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height);
$decd7d15e600d75d$var$renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
$decd7d15e600d75d$var$renderer.setClearColor($decd7d15e600d75d$var$parameters.currentTheme.bg);
/**
 * Postprocessing
 */ const $decd7d15e600d75d$var$composer = new (0, $2HSCJ.EffectComposer)($decd7d15e600d75d$var$renderer);
$decd7d15e600d75d$var$composer.antialias = true;
$decd7d15e600d75d$var$composer.setSize($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height);
$decd7d15e600d75d$var$composer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
const $decd7d15e600d75d$var$renderPass = new (0, $l1cPW.RenderPass)($decd7d15e600d75d$var$scene, $decd7d15e600d75d$var$camera);
$decd7d15e600d75d$var$composer.addPass($decd7d15e600d75d$var$renderPass);
const $decd7d15e600d75d$var$outlinePass = new (0, $3b5dbdf1656506ea$export$356dcb7105dbd3ee)(new $ilwiq.Vector2($decd7d15e600d75d$var$sizes.width, $decd7d15e600d75d$var$sizes.height), $decd7d15e600d75d$var$scene, $decd7d15e600d75d$var$camera);
$decd7d15e600d75d$var$outlinePass.edgeThickness = 4;
$decd7d15e600d75d$var$outlinePass.edgeStrength = 10;
$decd7d15e600d75d$var$outlinePass.visibleEdgeColor.set($decd7d15e600d75d$var$parameters.currentTheme.outline);
$decd7d15e600d75d$var$outlinePass.hiddenEdgeColor.set($decd7d15e600d75d$var$parameters.currentTheme.outline);
$decd7d15e600d75d$var$composer.addPass($decd7d15e600d75d$var$outlinePass);
const $decd7d15e600d75d$var$horizontalBlurPass = new (0, $9ajTk.ShaderPass)((0, $651d56ec53f2d352$export$80bd9f7edd9f435));
$decd7d15e600d75d$var$horizontalBlurPass.uniforms.h.value = 0 / $decd7d15e600d75d$var$sizes.width;
$decd7d15e600d75d$var$composer.addPass($decd7d15e600d75d$var$horizontalBlurPass);
const $decd7d15e600d75d$var$verticalBlurPass = new (0, $9ajTk.ShaderPass)((0, $49a69b08c8e2030f$export$36776cbd03410684));
$decd7d15e600d75d$var$verticalBlurPass.uniforms.v.value = 0 / $decd7d15e600d75d$var$sizes.height;
$decd7d15e600d75d$var$composer.addPass($decd7d15e600d75d$var$verticalBlurPass);
// const fxaaPass = new ShaderPass( FXAAShader )
// fxaaPass.uniforms.resolution.value.x = 1/(sizes.width*renderer.pixelRatio)
// fxaaPass.uniforms.resolution.value.y = 1/(sizes.height*renderer.pixelRatio)
// composer.addPass( fxaaPass )
const $decd7d15e600d75d$var$applyDistanceBlur = ()=>{
    let d = $decd7d15e600d75d$var$camera.position.distanceTo($decd7d15e600d75d$var$rootGroup.position);
    d = Math.max(0, $decd7d15e600d75d$var$remap(d, $decd7d15e600d75d$var$minDistance, $decd7d15e600d75d$var$maxDistance, 0, 0.75));
    $decd7d15e600d75d$var$horizontalBlurPass.uniforms.h.value = d / $decd7d15e600d75d$var$sizes.width;
    $decd7d15e600d75d$var$verticalBlurPass.uniforms.v.value = d / $decd7d15e600d75d$var$sizes.height;
    $decd7d15e600d75d$var$camera.lookAt($decd7d15e600d75d$var$rootGroup.position);
};
$decd7d15e600d75d$var$applyDistanceBlur();
const $decd7d15e600d75d$var$modalBlur = (t)=>{
    var u = {
        hv: $decd7d15e600d75d$var$secretShowing ? 3 / $decd7d15e600d75d$var$sizes.width : 0,
        vv: $decd7d15e600d75d$var$secretShowing ? 3 / $decd7d15e600d75d$var$sizes.height : 0
    };
    gsap.to(u, {
        hv: $decd7d15e600d75d$var$secretShowing ? 3 / $decd7d15e600d75d$var$sizes.width : 0,
        duration: 0.4,
        onUpdate: ()=>{
            $decd7d15e600d75d$var$horizontalBlurPass.uniforms.h.value = u.hv;
        }
    });
    gsap.to(u, {
        vv: $decd7d15e600d75d$var$secretShowing ? 3 / $decd7d15e600d75d$var$sizes.height : 0,
        duration: 0.4,
        onUpdate: ()=>{
            $decd7d15e600d75d$var$verticalBlurPass.uniforms.v.value = u.vv;
        }
    });
};
/**
 * Animate
 */ const $decd7d15e600d75d$var$clock = new $ilwiq.Clock();
const $decd7d15e600d75d$var$tick = ()=>{
    const elapsedTime = $decd7d15e600d75d$var$clock.getElapsedTime();
    if ($decd7d15e600d75d$var$linkSpeaker) $decd7d15e600d75d$var$linkSpeaker.rotation.y += 0.0015;
    if ($decd7d15e600d75d$var$linkPinata) $decd7d15e600d75d$var$linkPinata.rotation.y -= 0.00125;
    if ($decd7d15e600d75d$var$linkWaves) $decd7d15e600d75d$var$linkWaves.rotation.y -= 0.00175;
    if ($decd7d15e600d75d$var$linkText) $decd7d15e600d75d$var$linkText.rotation.y += 0.0025;
    if ($decd7d15e600d75d$var$linkParticles) $decd7d15e600d75d$var$linkParticles.rotation.y += 0.002;
    if ($decd7d15e600d75d$var$linkPatterns) $decd7d15e600d75d$var$linkPatterns.rotation.y -= 0.002;
    if (!$decd7d15e600d75d$var$loaded) $decd7d15e600d75d$var$applyDistanceBlur();
    // Render
    $decd7d15e600d75d$var$renderer.render($decd7d15e600d75d$var$scene, $decd7d15e600d75d$var$camera);
    $decd7d15e600d75d$var$composer.render();
    // Call tick again on the next frame
    window.requestAnimationFrame($decd7d15e600d75d$var$tick);
};
$decd7d15e600d75d$var$tick();
function $decd7d15e600d75d$var$remap(number, inMin, inMax, outMin, outMax) {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
const $decd7d15e600d75d$var$secretTunnels = document.getElementById("secret-tunnels");
var $decd7d15e600d75d$var$secretShowing = false;
document.addEventListener("keydown", (e)=>{
    if (e.key === "s") {
        $decd7d15e600d75d$var$secretShowing = !$decd7d15e600d75d$var$secretShowing;
        $decd7d15e600d75d$var$modalBlur($decd7d15e600d75d$var$secretShowing);
        gsap.fromTo($decd7d15e600d75d$var$secretTunnels, {
            scale: $decd7d15e600d75d$var$secretShowing ? 0.5 : 1
        }, {
            scale: $decd7d15e600d75d$var$secretShowing ? 1 : 0.5,
            duration: 0.4,
            ease: $decd7d15e600d75d$var$secretShowing ? "elastic.out(1, 1.1)" : "elastic.in(1, 1.1)"
        });
        gsap.to($decd7d15e600d75d$var$secretTunnels, {
            opacity: $decd7d15e600d75d$var$secretShowing ? 1 : 0,
            duration: 0.25,
            delay: $decd7d15e600d75d$var$secretShowing ? 0 : 0.35
        });
        $decd7d15e600d75d$var$secretTunnels.style.pointerEvents = $decd7d15e600d75d$var$secretShowing ? "all" : "none";
        if ($decd7d15e600d75d$var$secretShowing) $decd7d15e600d75d$var$secretTunnels.style.display = "flex";
        else gsap.delayedCall(0.4, ()=>{
            $decd7d15e600d75d$var$secretTunnels.style.display = "none";
        });
    }
});


//# sourceMappingURL=index.27f6964e.js.map
